import React from "react";

const BatchCard = ({ batchDetails }) => {
  const formatDate = (val) => {
    const date = new Date(val);

    const formatted = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    return formatted;
  };

  return (
    <div className="border-[1px] text-[.85rem] border-[#E8E2D9] rounded-[8px] shadow px-[1.2rem] py-[1rem] flex flex-col gap-[.3rem]">
      <div className="text-[#101828] font-semibold text-[.98rem]">
        {batchDetails?.batchName || "N/A"} <span></span>
      </div>
      <div className="text-[#475467] transition">
        {batchDetails?.totalCandidateCount} student(s) assigned
      </div>
      <div className="text-[#475467]">
        Created on{" "}
        {batchDetails?.batchCreatedDate
          ? formatDate(batchDetails?.batchCreatedDate)
          : "N/A"}
      </div>
      <div className="mt-[.2rem] flex gap-2 items-center flex-wrap">
        {batchDetails?.tags?.map((item, i) => (
          <div key={i} className="px-[.5rem] py-[.12rem] rounded-full border border-[#FEDF89] bg-[#FFFAEB] text-[.77rem] font-medium text-[#B54708]">
            {item}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BatchCard;
